import React, {Component} from 'react';
import PropTypes from 'prop-types';

import axios from "axios/index";
import {SkyLightStateless} from 'react-skylight';
import swal from 'sweetalert2';

import urls from "../../../../utils/urls";
import helpers from "../../../../utils/helpers";
import {ajaxHandler} from "../../../../utils/errors";
import {tokenHeader} from "../../../../utils/headers";
import translator from "../../../../utils/translations";
import { Spinner } from '../../../../components/Loading/Spinner';


export default class TripRejectModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            trip: props.trip,

            // Rejection
            rejection_reasons: false,
            rejection_reason: '',
            rejection_observations: '',
            showModal: !(!this.props.source),

            warn_reason: false,
            warn_observation: false,
            ajaxInProgress: false
        }
    }

    componentDidMount() {
        this._fetchOptions();
    }

    _initializeHtml = () => {
        window.initializeCollapsible();
        window.initializeSelects('body');
        window.bindSelectAction(this.reasonSelect, this._handleSelectChange);
    };

    _fetchOptions = () => {
        const REASONS_URL = `${urls.API_ROOT}/api/v1/rejectionreasons/`;
        axios.get(REASONS_URL, tokenHeader())
            .then((response) => {
                this.setState({
                    rejection_reasons: response.data.filter(rr => rr.trip_type === helpers.trip_type.INTERNAL)
                }, this._initializeHtml);
            })
            .catch((error) => ajaxHandler(error));
    };

    _closeModal = () => {
        this.setState({showModal: false});

        if(this.props.afterCloseAction){
            this.props.afterCloseAction();
        }
    };

    _handleInput = (prop, value) => {
        this.setState({[prop]: value});
    };

    _handleSelectChange = (ev) => {
        let target = ev.target;
        this.setState({
            [target.getAttribute('data-state-var')]: target.value
        });
    };

    _submitRejection = () => {
        if(!(this.state.rejection_reason && this.state.rejection_observations)){
            let warn_reason = !this.state.rejection_reason;
            let warn_observation = !this.state.rejection_observations;
            this.setState({warn_observation, warn_reason});
            return false;
        }

        this.setState({ajaxInProgress: true, warn_observation: false, warn_reason: false});
        let {rejection_reason, rejection_observations} = this.state;

        let data = {
            next_status: 'E1',
            rejection_observations,
            rejection_reason
        };

        const SHIPMENT_URL = `${urls.API_ROOT}/api/v1/trip/id/${this.state.trip.id}/`;
        axios.put(`${SHIPMENT_URL}`, data, tokenHeader())
            .then(() => this.setState({showModal: false}))
            .then(this._onRejectSuccess)
            .catch(this._onSubmitError);
    };

    _onRejectSuccess = () => {

        swal({
            title: 'Viaje rechazado',
            html: 'El viaje ha sido rechazado correctamente. Espere unos segundos por favor',
            type: 'success',
            showConfirmButton: false,
            timer: 3000
        });

        setTimeout(this.props.reloadTrip, 3000);
    };

    _onSubmitError = (error) => {
        this.setState({ajaxInProgress: false});
        try{
            let response = error.response;
            if(response.status === 400){
                let keys = Object.keys(response.data);
                let details = '';
                for(let i in keys){
                    details = `${details} <p><b>${translator.getFieldName(keys[i])}:</b> ${response.data[keys[i]].join(' ')}</p>`;
                }
                let body = `<div class='swal-container'><p>Se han encontrado los siguientes errores: </p>${details}</div>`;
                swal({
                    title: 'No se ha podido rechazar el viaje',
                    html: body,
                    type: 'error'
                });
            }else{
                ajaxHandler(error);
            }
        }
        catch (e){
            ajaxHandler(error);
        }
    };


    render() {

        // Waiting for options
        if(!this.state.rejection_reasons){
            return <div />;
        }

        let modalStyle = {
            boxShadow: 'none'
        };

        let buttonsDisabled = this.state.ajaxInProgress;

        return (
            <div className={"text-right"}>
                {this.props.showButton &&
                <button className={'btn btn-shell-empty z-depth-0'}
                        onClick={() => this.setState({showModal: true})}>
                    Rechazar viaje
                </button>
                }
                <SkyLightStateless
                    onOverlayClicked={this._closeModal}
                    isVisible={this.state.showModal}
                    onCloseClicked={this._closeModal}
                    dialogStyles={modalStyle}
                    title={<h3 className="center" style={{fontSize: '30px'}}>Rechazo de viaje</h3>}
                >
                    <div className={"row margin-top-20 text-left"}>
                        <div className={"col s12"}>
                            <p>{this.props.message}</p>
                        </div>
                        <div className={"col s12 margin-top-30"}>
                            <div className={`input-field ${this.state.warn_reason ? 'error-input' : ''}`} >
                                <label className="active">Motivo rechazo</label>
                                <select defaultValue={this.state.rejection_reason}
                                        data-state-var="rejection_reason"  ref={ref => {this.reasonSelect = ref}}>
                                    <option value="">Seleccione el motivo</option>
                                    {this.state.rejection_reasons && this.state.rejection_reasons.map(reason => {
                                        return <option key={reason.id} id={reason.id}
                                                       value={reason.id}>{reason.text}</option>
                                    })}
                                </select>
                                {this.state.warn_reason &&
                                <div className={'shell-red-text'} style={{marginBottom: '20px'}}>
                                    * Seleccione el motivo de rechazo
                                </div>
                                }
                            </div>
                        </div>
                        <div className={`col s12 input-field ${this.state.warn_observation ? 'error-input' : ''}`}>
                            <label className="active">Observaciones</label>
                            <textarea
                                className={"materialize-textarea dispatch-textarea"} rows={4}
                                onChange={(ev) => this._handleInput('rejection_observations', ev.target.value)}
                                defaultValue={this.state.rejection_observations}
                            />
                            {this.state.warn_observation &&
                            <div className={'shell-red-text'}>* Ingrese observaciones</div>
                            }
                        </div>
                        <div className={"col s12 center margin-top-30"}>
                            <button className={`btn btn-shell-empty z-depth-0 ${buttonsDisabled ? 'disabled' : ''}`}
                                    onClick={this._closeModal}>
                                Cancelar
                            </button>
                            <button className={`btn btn-shell z-depth-0 ${buttonsDisabled ? 'disabled' : ''}`} onClick={this._submitRejection}>
                                Rechazar viaje
                            </button>
                        </div>
                    </div>
                    {this.state.ajaxInProgress ? <Spinner /> : <div><br/><br/></div>}
                </SkyLightStateless>
            </div>
        );
    }
}


TripRejectModal.propTypes = {
    showButton: PropTypes.bool
};

TripRejectModal.defaultProps = {
    showButton: true,
    message: 'Usted está por rechazar el viaje. Para continuar, complete el formulario debajo'
};


// WEBPACK FOOTER //
// ./src/containers/Dashboard/InternalTrips/Trip/TripRejectModal.js